import React, { useMemo } from 'react';
import { Container } from 'reactstrap';

import CenteredLoader from '../../../components/CenteredLoader/CenteredLoader';
import CoursesList from '../../../components/CoursesList/CoursesList';
import UncontrolledSlider from '../../../components/UncontrolledSlider/UncontrolledSlider';
import Helmet from '../../../components/common/Helmet';
import useTranslate from '../../../hooks/useTranslate';
import useGolfCourses from '../../../services/apis/golfCourses/api';

const SummerSalePage = () => {
  const { translate } = useTranslate();

  const { data, isLoading } = useGolfCourses();
  const golfCourses = useMemo(
    () =>
      data?.filter(
        course => course.golfCourse.campaignPercentage && course.golfCourse.campaignPercentage > 0
      ),
    [data]
  );

  const slides = useMemo(
    () => [
      {
        title: (
          <>
            <div className="display-1 fw-bold text-uppercase mb-3">
              {translate('campaign-summer-sale.top-banner.title')}
            </div>
            <div className="display-6">
              {translate('campaign-summer-sale.top-banner.description')}
            </div>
          </>
        ),
        description: '',
        image: require('./campaign-2025-summer-sale.jpg'),
        placeholder: `data:image/bmp;base64,Qk1aBAAAAAAAADYAAAAoAAAABAAAAAMAAAABABgAAAAAACQAAAATCwAAEwsAAAAAAAAAAAAAW1A+TWFkXGhqiHp1eHpxcYeHgpOVqqelcYWEdY+ThaGkpLS1`,
      },
    ],
    [translate]
  );

  return (
    <>
      <Helmet
        titleTranslationKey="campaign-summer-sale.helmet.title"
        descriptionTranslationKey="campaign-summer-sale.helmet.description"
      />
      <UncontrolledSlider slides={slides} />

      <Container className="my-5">
        <p>{translate('campaign-summer-sale.description.p-1')}</p>
        <p>{translate('campaign-summer-sale.description.p-2')}</p>
        <ul>
          <li>{translate('campaign-summer-sale.description.li-1')}</li>
          <li>{translate('campaign-summer-sale.description.li-2')}</li>
          <li>{translate('campaign-summer-sale.description.li-3')}</li>
        </ul>

        <p>{translate('campaign-summer-sale.description.p-3')}</p>

        {!isLoading && !!golfCourses && golfCourses.length > 0 && (
          <>
            <h2 className="my-4">{translate('campaign-summer-sale.description.sub-title')}</h2>
            <CoursesList courses={golfCourses} />
          </>
        )}

        {isLoading && <CenteredLoader message={String(translate('Courses.LoadingGolfCourses'))} />}
      </Container>
    </>
  );
};

export default SummerSalePage;
